var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"content has-text-centered"},[_c('p',{staticClass:"pa-0 ma-0"},[_vm._v(" © "),_c('a',{attrs:{"href":"https://lk.mizaem.ru/admin-login"}},[_vm._v("Mizaem.ru")]),_vm._v(" Отправка сообщений, 2023 ")])])])
}]

export { render, staticRenderFns }